/* eslint-env jest */
import R from 'ramda'

const MENTION_TRIGGER_TYPE = 'MENTION'
const MENTION_DISPLAY_TYPE = 'Match handle'

const isMentionWidgetTrigger = R.propEq('type', MENTION_TRIGGER_TYPE)

const convertMentionWidgetTriggerToFormTrigger = R.applySpec({
  type: R.always(MENTION_DISPLAY_TYPE),
  handles: R.prop('data')
})

export { isMentionWidgetTrigger, convertMentionWidgetTriggerToFormTrigger }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/twitter/widget-to-form/mention.js